import $ from "jquery";
//friendly-challenge/widget
//import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk"
import { WidgetInstance } from "friendly-challenge";
export default class FriendlyCaptcha {
    static mount() {
        $('.frc-captcha').each(function () {
            const widget = new WidgetInstance(this, {
                sitekey: $(this).data('sitekey')
            });
        });
    }
}
